module.exports = __webpack_public_path__ + "img/process_img05.04818bf0.png";